import type { CelebrationPreset, IntensityMultiplier, CelebrationIntensity, CelebrationType } from './types';

/**
 * Preset configurations for celebration effects
 */
export const CELEBRATION_PRESETS: Record<CelebrationType, CelebrationPreset> = {
  confetti: {
    colors: ['#9F7AEA', '#B794F4', '#D6BCFA', '#FAF089', '#F6E05E'], // Purple/Yellow theme
    particleCount: 100,
    spread: 70,
    shapes: ['circle', 'square'],
    gravity: 1,
    scalar: 1,
  },
  fire: {
    colors: ['#ff4500', '#ff6b35', '#ffa500', '#ffcc00', '#8b0000'], // Fire colors
    particleCount: 100,
    spread: 70,
    shapes: ['circle'],
    gravity: 1.2,
    scalar: 1.2,
  },
} as const;

/**
 * Intensity multipliers for particle count and spread
 */
export const INTENSITY_MULTIPLIERS: Record<CelebrationIntensity, IntensityMultiplier> = {
  low: { particleCount: 0.5, spread: 0.7 },
  medium: { particleCount: 1, spread: 1 },
  high: { particleCount: 1.5, spread: 1.2 },
} as const;

/**
 * Default values for celebration options
 */
export const CELEBRATION_DEFAULTS = {
  type: 'confetti' as CelebrationType,
  intensity: 'medium' as CelebrationIntensity,
  zIndex: 1000,
  origin: { x: 0.5, y: 0.6 },
  withSideBursts: false,
  sideBurstDelay: 150,
} as const;
